/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { login, getProfile } from "./../components/auth/UserFunctions";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  FormInput,
  FormCheckbox,
  Button
} from "shards-react";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      loading: false,
      errors: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit(e) {
    this.setState({ loading: true });
    this.setState({ message: "" });
    e.preventDefault();

    const user = {
      email: this.state.email,
      password: this.state.password
    };

    login(user).then(async res => {
      if (localStorage.userToken) {
        var profile = await getProfile();
        if (profile.layout === "ClientLayout") {
          this.props.history.push("/clients");
        } else {
          this.props.history.push("/pending");
        }
      } else if (res.response) {
        if (res.response.status == 400 || res.response.status == 401) {
          this.setState({ message: "Usuario y/o contraseña incorrectos" });
        } else if (res.response.status == 429) {
          this.setState({
            message:
              "Muchos intentos seguidos. Por favor reintente en unos minutos"
          });
        }
        this.setState({ loading: false });
      } else {
        this.props.history.push("/errors");
      }
    });
  }

  render() {
    require("dotenv").config();
    return (
      <Container fluid className="main-content-container h-100 px-4">
        <Row noGutters className="h-100">
          <Col lg="3" md="5" className="auth-form mx-auto my-auto">
            <Card>
              <CardBody>
                {/* Logo */}
                <img
                  className="auth-form__logo d-table mx-auto mb-3"
                  src={require("../images/logoautocorp.png")}
                  alt="Shards Dashboards - Login Template"
                />

                {/* Title */}
                <h5 className="auth-form__title text-center mb-4">
                  Login {process.env.REACT_APP_NAME}
                </h5>
                {/* Form Fields */}
                <Form onSubmit={this.onSubmit}>
                  <FormGroup>
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <FormInput
                      type="email"
                      name="email"
                      id="exampleInputEmail1"
                      placeholder="Ingresa tu email"
                      autoComplete="email"
                      value={this.state.email}
                      invalid={this.state.message}
                      onChange={this.onChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label htmlFor="exampleInputPassword1">Password</label>
                    <FormInput
                      type="password"
                      name="password"
                      id="exampleInputPassword1"
                      placeholder="Ingresa tu contraseña"
                      autoComplete="current-password"
                      value={this.state.password}
                      invalid={this.state.message}
                      onChange={this.onChange}
                    />
                  </FormGroup>
                  {this.state.message ? (
                    <label style={{ color: "red" }}>{this.state.message}</label>
                  ) : (
                    ""
                  )}

                  <FormGroup>
                    <FormCheckbox>Recordar mi contraseña.</FormCheckbox>
                  </FormGroup>
                  <Button
                    pill
                    theme="accent"
                    className="d-table mx-auto"
                    type="submit"
                    disabled={this.state.loading ? true : false}
                  >
                    {!this.state.loading ? "Login" : "Autenticando..."}
                  </Button>
                </Form>
                <CardFooter>
                  <Link to="/forgot-password">Olvido su contraseña?</Link>
                </CardFooter>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Login;
